import request from '@/utils/request'


// 查询寄存列表
export function listDeposit(query) {
  return request({
    url: '/deposit/deposit/list',
    method: 'get',
    params: query
  })
}

// 查询寄存分页
export function pageDeposit(query) {
  return request({
    url: '/deposit/deposit/page',
    method: 'get',
    params: query
  })
}

// 查询寄存详细
export function getDeposit(data) {
  return request({
    url: '/deposit/deposit/detail',
    method: 'get',
    params: data
  })
}

// 新增寄存
export function addDeposit(data) {
  return request({
    url: '/deposit/deposit/add',
    method: 'post',
    data: data
  })
}

// 修改寄存
export function updateDeposit(data) {
  return request({
    url: '/deposit/deposit/edit',
    method: 'post',
    data: data
  })
}

// 删除寄存
export function delDeposit(data) {
  return request({
    url: '/deposit/deposit/delete',
    method: 'post',
    data: data
  })
}
